export const memorialGuideGreetings = {
  funeralHomes:
    'Hi, I can help explain how HexForge memorial keepsakes work as an optional referral resource for families.',
  memorial:
    'Hi, I can help answer questions about custom memorial photo keepsakes, photo review, and how to start a request.'
};

export const memorialGuideFallback =
  'I don’t want to guess on that. I can help send this question to HexForge Labs so Luke can respond directly.';

export const memorialGuidePricingTerms = [
  'discount',
  'discounts',
  'bulk',
  'several',
  'multiple',
  'more than one price',
  'bundle price',
  'family set price',
  'deal',
  'cheaper',
  'wholesale',
  'volume',
  'volume discount',
  'commission',
  'referral fee',
  'package price',
  'order several',
  'order multiple'
];

export const memorialGuideEntries = [
  {
    id: 'what-is-it',
    label: 'What is a memorial lamp?',
    keywords: ['what is', 'lithophane', 'memorial lamp', 'photo lamp', 'keepsake lamp', 'lamp'],
    answer:
      'A memorial lithophane lamp is a custom lamp made from a photo. When the lamp is lit from inside, the image becomes visible through the printed shade, creating a soft illuminated keepsake.'
  },
  {
    id: 'how-photo-works',
    label: 'How does the photo work?',
    keywords: ['how does the photo', 'how does photo', 'how does it work', 'image appear', 'photo appear', 'when lit', 'light shines'],
    answer:
      'The photo is converted into a lithophane-style surface. When light shines through the printed material, the image appears as an illuminated portrait or memory scene.'
  },
  {
    id: 'photo-guidance',
    label: 'What photos work best?',
    keywords: ['photo work', 'photos work', 'picture work', 'photo guidance', 'best photo', 'clear photo', 'low resolution'],
    answer:
      'A clear, well-lit photo usually works best, but older or scanned family photos may still be reviewed. HexForge Labs will look at the image first and explain what should work before making anything.'
  },
  {
    id: 'old-photo',
    label: 'Can I use an old photo?',
    keywords: ['old photo', 'older photo', 'scanned photo', 'scan', 'faded photo'],
    answer:
      'Yes. Older family photos may be reviewed. A scan or clear phone photo of the original can help.'
  },
  {
    id: 'privacy',
    label: 'How are photos handled?',
    keywords: ['privacy', 'private', 'photos handled', 'used publicly', 'public display', 'marketing', 'social media', 'permission'],
    answer:
      'Family photos are handled respectfully and are not used for public display, marketing, examples, or social media without permission.'
  },
  {
    id: 'family-set',
    label: 'Can I order more than one?',
    keywords: ['more than one', 'family set', 'family keepsake set', 'multiple', 'close relatives'],
    answer:
      'Yes. A family keepsake set can be discussed for close relatives or multiple display locations.'
  },
  {
    id: 'family-start',
    label: 'How does a family start?',
    keywords: ['how do i start', 'how does a family start', 'start a request', 'place an order', 'order one', 'order'],
    answer:
      'A family can start through the memorial keepsake request page or contact HexForge Labs with their name, the keepsake option they are interested in, and whether they already have a photo selected.'
  },
  {
    id: 'funeral-home-process',
    label: 'How does the referral work?',
    keywords: ['funeral home', 'director', 'referral', 'information sheet', 'qr code'],
    answer:
      'Funeral homes can share the information sheet or QR code when a family asks about personalized keepsakes. Families work directly with HexForge Labs for photo review, ordering, payment, and fulfillment.'
  },
  {
    id: 'funeral-home-burden',
    label: 'Who handles photos and payment?',
    keywords: ['funeral home collect', 'collect photos', 'collect payment', 'manage photos', 'manage payment', 'fulfillment', 'inventory'],
    answer:
      'Families work directly with HexForge Labs unless a different arrangement is discussed later. The funeral home does not need to collect photos, process payment, manage inventory, or handle fulfillment.'
  },
  {
    id: 'optional-item',
    label: 'Does this replace other services?',
    keywords: ['replace funeral', 'replace flowers', 'replace urn', 'existing services', 'optional item'],
    answer:
      'No. These keepsakes are optional personal items and are not meant to replace flowers, printed materials, urns, or existing funeral home services.'
  },
  {
    id: 'info-packet',
    label: 'Can I request an info packet?',
    keywords: ['info packet', 'information packet', 'more information', 'funeral home information'],
    answer:
      'Yes. Funeral homes can request an information packet from HexForge Labs.'
  },
  {
    id: 'sample',
    label: 'Can a director ask about a sample?',
    keywords: ['sample', 'display discussion', 'director sample'],
    answer:
      'Yes. A director sample or display discussion can be requested after reviewing the information packet.'
  },
  {
    id: 'pricing',
    label: 'What about pricing?',
    keywords: ['price', 'pricing', 'cost', 'how much'],
    answer:
      'Discounts or set pricing can depend on the keepsake option and order details. I don’t want to guess on that. I can help send this question to HexForge Labs so Luke can respond directly.',
    needsEscalation: true
  },
  {
    id: 'timing',
    label: 'How long does it take?',
    keywords: ['time', 'timing', 'turnaround', 'how long', 'ship date', 'delivery date', 'when ready'],
    answer:
      'Timing can depend on photo review, current workload, and the keepsake option. HexForge Labs should confirm timing directly before anyone relies on a date.'
  },
  {
    id: 'contact',
    label: 'How do I contact HexForge Labs?',
    keywords: ['contact', 'email', 'talk to luke', 'reach hexforge', 'appointment'],
    answer:
      'You can contact HexForge Labs through the Request Info link. Calls or in-person visits are available by appointment.'
  }
];

export const memorialGuideBlockedTopics = [
  'admin',
  'assistant',
  'script lab',
  'heightmap',
  'surface',
  'security tool',
  'keylogger',
  'badusb',
  'refund',
  'return policy',
  'legal advice',
  'medical advice',
  'therapy',
  'grief counseling',
  'funeral law'
];
